import { KompisIcon } from '@inter-ikea-kompis/react-components';
import React from 'react';
import Box from 'ui/Box';
import { LayoutProps, SpaceProps } from 'styled-system';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

type Props = LayoutProps &
  SpaceProps & {
    icon: any;
    id?: string;
  };

const Icon = ({ icon, ...props }: Props) => {
  return (
    <Box {...props}>
      <KompisIcon theme={SkapaTheme} icon={icon} />
    </Box>
  );
};

export default Icon;
